import { FixedPricePrefixType } from '~/api/services/dashboard';
import { RouteTypes } from '../../routes/constants';
import i18n from '~/components/i18n';
import {
  ADMIN_ROLE_SLUG,
  CLIMATE_CHECK_SLUG,
  CO2_LFL_SLUG,
  FAT_PROTEIN_SLUG,
  LIGHT_USER_ROLE_SLUG,
  MILK_FIXED_SLUG,
  MILK_MONEY_ACCOUNT_SLUG,
  MILK_STOCK_EXCHANGE,
  milkSamplesIDs,
  OPERATIVE_ROLE_SLUG
} from '~/Constants';

export const getSideMenuDairyItems = () => [
  {
    id: 'dairy',
    title: i18n.t('Dairy Factory'),
    iconClassName: 'icon-factory font-size-3',
    displayForRole: [ADMIN_ROLE_SLUG, LIGHT_USER_ROLE_SLUG, OPERATIVE_ROLE_SLUG],
    children: [
      {
        id: 'dairy-profile',
        title: i18n.t('Dairy Profile'),
        iconClassName: 'icon-factory font-size-2-m',
        link: RouteTypes.DAIRY_FACTORY_PROFILE_USERS,
        changeLinkRole: [LIGHT_USER_ROLE_SLUG, OPERATIVE_ROLE_SLUG],
        changeLinkUrl: RouteTypes.DAIRY_FACTORY_PROFILE_LOCATIONS
      },
      {
        id: 'farmers',
        title: i18n.t('Farmers'),
        iconClassName: 'icon-farmer-icon font-size-2-m',
        link: RouteTypes.DAIRY_FACTORY_FARMERS
      },
      {
        id: 'stonex-ble-cash',
        slug: MILK_STOCK_EXCHANGE,
        title: 'StoneX BLE Cash S.',
        iconClassName: 'signup font-size-2-m',
        link: RouteTypes.DAIRY_FACTORY_STONE_X_BLE
      },
      {
        id: 'farmer-users',
        title: i18n.t('Farmer Users'),
        iconClassName: 'icon-user-group font-size-2-m',
        link: RouteTypes.DAIRY_FACTORY_FARMER_USERS
      },
      {
        id: 'activity-logs',
        title: i18n.t('Activity Logs'),
        iconClassName: 'file text font-size-2-m',
        link: RouteTypes.DAIRY_FACTORY_PRICE_ACTIVITY_LOGS
      }
    ]
  },
  {
    id: 'future_contracts',
    slug: 'future_contracts',
    title: i18n.t('Future contracts'),
    iconClassName: 'icon-contract-1 font-size-3',
    children: [
      {
        id: 'stonex',
        slug: 'stonex',
        title: i18n.t('StoneX'),
        iconClassName: 'signup font-size-2-m',
        link: RouteTypes.FUTURE_CONTRACTS_STONEX
      },
      {
        id: 'ife_stock_market_milk_value',
        slug: 'ife_stock_market_milk_value',
        title: i18n.t('Ife stock milk value'),
        iconClassName: 'icon-euro font-size-2-m',
        link: RouteTypes.FUTURE_CONTRACTS_TYPES.replace(':contractsType', 'ife-quotes')
      },
      {
        id: 'initial_margin',
        slug: 'initial_margin',
        title: i18n.t('Initial Margin'),
        iconClassName: 'icon-euro font-size-2-m',
        link: RouteTypes.FUTURE_CONTRACTS_TYPES.replace(':contractsType', 'initial-margins')
      },
      {
        id: 'eod_quotes',
        slug: 'eod_quotes',
        title: i18n.t('EEX Settlement'),
        iconClassName: 'icon-euro font-size-2-m',
        link: RouteTypes.FUTURE_CONTRACTS_TYPES.replace(':contractsType', 'eod-quotes')
      }
    ]
  },
  {
    id: 'milk_money_accounting',
    slug: MILK_MONEY_ACCOUNT_SLUG,
    title: i18n.t('Milk money'),
    iconClassName: 'icon-three-euro-paper-bills font-size-2-m',
    children: [
      {
        id: 'icon-tour-planing',
        title: i18n.t('Tour planning'),
        iconClassName: 'time font-size-2-m font-size-2-m',
        link: RouteTypes.MILK_MONEY_TOUR_PLANNING
      },
      {
        id: 'milk-delivery-tours',
        title: i18n.t('Overview MSW Tours'),
        iconClassName: 'truck font-size-2-m',
        link: RouteTypes.MILK_MONEY_DELIVERY
      },
      {
        id: 'milk-samples',
        title: i18n.t('Milk samples'),
        iconClassName: 'icon-results font-size-2-m',
        link: '/milk-samples',
        children: [
          {
            id: 'milk-samples-0',
            title: i18n.t('Daily samples'),
            iconClassName: 'icon-results font-size-2-m',
            link: RouteTypes.MILK_MONEY_SAMPLES_INDIVIDUAL.replace(':id', milkSamplesIDs.dailyValues)
          },
          {
            id: 'milk-samples-1',
            title: i18n.t('All individual values'),
            iconClassName: 'icon-results font-size-2-m',
            link: RouteTypes.MILK_MONEY_SAMPLES_INDIVIDUAL.replace(':id', milkSamplesIDs.allIndividual)
          },
          {
            id: 'milk-samples-2',
            title: i18n.t('Farmer average values'),
            iconClassName: 'icon-results font-size-2-m',
            link: RouteTypes.MILK_MONEY_SAMPLES_FARMER.replace(':id', milkSamplesIDs.farmer)
          },
          {
            id: 'milk-samples-3',
            title: i18n.t('Dairy averages values'),
            iconClassName: 'icon-results font-size-2-m',
            link: RouteTypes.MILK_MONEY_SAMPLES_DAIRY.replace(':id', milkSamplesIDs.dairy)
          },
          {
            id: 'milk-samples-4',
            title: i18n.t('Pseudom.'),
            iconClassName: 'icon-results font-size-2-m',
            link: RouteTypes.MILK_MONEY_SAMPLES_DAIRY.replace(':id', milkSamplesIDs.pseudom)
          }
        ]
      },
      {
        id: 'invoice',
        title: i18n.t('Invoice'),
        iconClassName: 'file alternate font-size-2-m',
        link: RouteTypes.MILK_MONEY_INVOICE
      },
      {
        id: 'ftp-logs',
        title: i18n.t('FTP logs'),
        iconClassName: 'archive font-size-2-m',
        link: RouteTypes.MILK_MONEY_FTP_LOGS,
        displayForRole: [ADMIN_ROLE_SLUG]
      }
    ]
  },
  {
    id: 'co2-climate-check',
    slug: CO2_LFL_SLUG,
    title: '<div>CO<sub>2</sub> Klima Check</div>',
    iconClassName: 'leaf font-size-2-m',
    link: RouteTypes.CO2_CLIMATE
  },
  {
    id: 'climate-check',
    slug: CLIMATE_CHECK_SLUG,
    title: i18n.t('Climate check'),
    iconClassName: 'leaf font-size-2-m',
    link: RouteTypes.CLIMATE_CHECK
  },
  {
    id: 'milk_fixed_price_stock_exchange',
    slug: MILK_FIXED_SLUG,
    title: i18n.t('Milk Fixed Price'),
    link: RouteTypes.MILK_FIXED_PRICE,
    iconClassName: 'euro sign font-size-3'
  },
  {
    id: 'milk_fixed_price_fat_and_protein',
    slug: FAT_PROTEIN_SLUG,
    title: i18n.t('Milk fixed price (F. & P.)'),
    link: RouteTypes.FAT_PROTEIN_PRICE,
    iconClassName: 'euro sign font-size-3'
  },
  {
    id: MILK_STOCK_EXCHANGE,
    slug: MILK_STOCK_EXCHANGE,
    title: i18n.t('Stock exchange'),
    link: RouteTypes.STOCK_EXCHANGE,
    iconClassName: 'euro sign font-size-3'
  },
  {
    id: 'reporting',
    slug: [MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE, MILK_MONEY_ACCOUNT_SLUG, FAT_PROTEIN_SLUG, CO2_LFL_SLUG],
    title: i18n.t('Reporting'),
    iconClassName: 'edit outline font-size-3',
    children: [
      {
        id: 'fat-protein-trading-activities',
        slug: FAT_PROTEIN_SLUG,
        title: i18n.t('Milk fixed price'),
        iconClassName: 'chart bar font-size-3',
        children: [
          {
            id: 'fat-protein-trading-activities',
            title: i18n.t('Trading activities'),
            iconClassName: 'chart bar font-size-2-m',
            link: RouteTypes.REPORTING_TRADING_ACTIVITIES.replace(':prefix', FixedPricePrefixType.FatProtein)
          },
          {
            id: 'fat-protein--price',
            title: i18n.t('Fixed price'),
            iconClassName: 'chart line font-size-2-m',
            link: RouteTypes.REPORTING_PRICE.replace(':prefix', FixedPricePrefixType.FatProtein)
          }
        ]
      },
      {
        id: 'fixed-price-trading-activities',
        slug: MILK_FIXED_SLUG,
        title: i18n.t('Milk fixed price'),
        iconClassName: 'chart bar font-size-3',
        children: [
          {
            id: 'trading-activities',
            title: i18n.t('Trading activities'),
            iconClassName: 'chart bar font-size-2-m',
            link: RouteTypes.REPORTING_TRADING_ACTIVITIES.replace(':prefix', FixedPricePrefixType.FixedPrice)
          },
          {
            id: 'fixed-dairy-price',
            title: i18n.t('Fixed price'),
            iconClassName: 'chart line font-size-2-m',
            link: RouteTypes.REPORTING_PRICE.replace(':prefix', FixedPricePrefixType.FixedPrice)
          }
        ]
      },
      {
        id: 'stock-exchange-trading-activities',
        slug: MILK_STOCK_EXCHANGE,
        title: i18n.t('Stock exchange'),
        iconClassName: 'chart bar font-size-2-m',
        children: [
          {
            id: 'trading-activities',
            title: i18n.t('Trading activities'),
            iconClassName: 'chart bar font-size-2-m',
            link: RouteTypes.REPORTING_TRADING_ACTIVITIES.replace(':prefix', FixedPricePrefixType.StockExchange)
          },
          {
            id: 'ble-dairy-price',
            title: i18n.t('BLE price'),
            iconClassName: 'chart line font-size-2-m',
            link: RouteTypes.REPORTING_PRICE.replace(':prefix', FixedPricePrefixType.StockExchange)
          }
        ]
      },
      {
        id: 'reporting-milk-payment',
        slug: MILK_MONEY_ACCOUNT_SLUG,
        title: i18n.t('Milk money'),
        iconClassName: 'icon-three-euro-paper-bills font-size-3',
        children: [
          {
            id: 'article-bookings',
            title: i18n.t('Article bookings'),
            iconClassName: 'shopping cart font-size-2-m',
            link: RouteTypes.REPORTING_ARTICLE_BOOKINGS
          },
          {
            id: 'delivery-district',
            title: i18n.t('Delivery district no'),
            iconClassName: 'truck line font-size-2-m',
            link: RouteTypes.REPORTING_DISTRICT_DELIVERY
          }
        ]
      },
      {
        id: 'co2-climate-check-reporting',
        slug: CO2_LFL_SLUG,
        title: '<div>CO<sub>2</sub> Klima Check</div>',
        iconClassName: 'leaf font-size-2-m',
        children: [
          {
            id: 'data-collections',
            title: i18n.t('Data collections'),
            iconClassName: 'database font-size-2-m',
            link: RouteTypes.REPORTING_CO2
          }
        ]
      }
    ]
  },
  {
    id: 'cloud-storage',
    slug: 'cloud_storage',
    title: i18n.t('Cloud storage'),
    link: RouteTypes.CLOUD_STORAGE,
    iconClassName: 'cloud download font-size-3'
  },
  {
    id: 'survey',
    slug: 'survey',
    title: i18n.t('Survey'),
    link: RouteTypes.SURVEY,
    iconClassName: 'icon-survey font-size-3'
  },
  {
    id: 'faq',
    slug: 'faq',
    title: i18n.t('FAQ'),
    link: RouteTypes.FAQ,
    iconClassName: 'question circle outline font-size-3'
  },
  {
    id: 'newsletter',
    slug: 'newsletter',
    title: i18n.t('Newsletter'),
    link: RouteTypes.NEWSLETTER,
    iconClassName: 'icon-content font-size-3'
  },
  {
    id: 'settings',
    title: i18n.t('Settings'),
    link: RouteTypes.SETTINGS,
    displayForRole: ['admin', 'user', 'ife'],
    iconClassName: 'icon-settings-gears font-size-3',
    children: [
      {
        id: 'settings-general',
        title: i18n.t('General'),
        link: RouteTypes.SETTINGS_GENERAL,
        iconClassName: 'icon-settings-gears font-size-2-m'
      },
      {
        id: 'co2-climate-check',
        slug: CO2_LFL_SLUG,
        title: '<div>CO<sub>2</sub> Klima Check</div>',
        iconClassName: 'leaf font-size-2-m',
        link: RouteTypes.SETTINGS_CO2_CLIMATE
      },
      {
        id: 'settings-climate-check',
        slug: CLIMATE_CHECK_SLUG,
        title: 'KPM',
        iconClassName: 'leaf font-size-2-m',
        link: RouteTypes.SETTINGS_CLIMA_CHECK
      },
      {
        id: 'settings-cloud-storage',
        slug: 'cloud_storage',
        title: i18n.t('Cloud storage'),
        link: RouteTypes.SETTINGS_CLOUD_STORAGE,
        iconClassName: 'cloud download font-size-2-m'
      },
      {
        id: 'settings-trading-slot',
        title: i18n.t('Trading slot'),
        slug: [MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE, FAT_PROTEIN_SLUG],
        iconClassName: 'icon-seeding font-size-2-m',
        link: RouteTypes.SETTINGS_TRADING_SLOT
      },
      {
        id: 'milk_money_accounting',
        slug: MILK_MONEY_ACCOUNT_SLUG,
        title: i18n.t('Milk money'),
        link: RouteTypes.SETTINGS_MILK_MONEY,
        iconClassName: 'clipboard list font-size-2-m'
      },
      {
        id: 'settings-security',
        title: i18n.t('Security'),
        iconClassName: 'icon-security-4 font-size-2-m',
        link: RouteTypes.SETTINGS_SECURITY
      },
      {
        id: 'settings-faq',
        slug: 'faq',
        title: i18n.t('FAQ Builder'),
        iconClassName: 'question circle outlinefont-size-2-m',
        link: RouteTypes.SETTINGS_FAQ
      },
      {
        id: 'login-popup',
        title: i18n.t('Login popups'),
        iconClassName: 'sign-in font-size-2-m',
        link: RouteTypes.SETTINGS_LOGIN_POPUP
      },
      {
        id: 'settings-messaging',
        title: i18n.t('Messaging'),
        iconClassName: 'comments font-size-2-m',
        link: RouteTypes.SEETINGS_MESSAGE
      },
      {
        id: 'ftp',
        title: i18n.t('FTP'),
        iconClassName: 'desktop font-size-2-m',
        link: RouteTypes.SETTINGS_FTP
      },
      {
        id: 'ftp-logs',
        title: i18n.t('FTP logs'),
        iconClassName: 'archive font-size-2-m',
        link: RouteTypes.SETTINGS_FTP_LOGS
      }
    ]
  }
];

export const getSideMenuFarmerItems = () => [
  {
    id: 'dashboard',
    title: i18n.t('Dashboard'),
    slug: [MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE, FAT_PROTEIN_SLUG, CO2_LFL_SLUG],
    iconClassName: 'icon-research font-size-3',
    link: RouteTypes.DASHBOARD
  },
  {
    id: 'my-farm',
    title: i18n.t('My farm'),
    iconClassName: 'icon-farmer-icon font-size-3',
    link: RouteTypes.FARMER_PROFILE
  },
  {
    id: 'milk-delivery-farmer-money',
    title: i18n.t('Milk delivery'),
    iconClassName: 'truck font-size-3',
    slug: MILK_MONEY_ACCOUNT_SLUG,
    link: RouteTypes.FARM_MILK_DELIVERY
  },
  {
    id: 'milk-quality',
    title: i18n.t('Milk quality'),
    slug: MILK_MONEY_ACCOUNT_SLUG,
    iconClassName: 'icon-research font-size-3',
    link: RouteTypes.FARM_MILK_QUALITY
  },
  {
    id: 'milk-money',
    title: i18n.t('Milk money'),
    slug: MILK_MONEY_ACCOUNT_SLUG,
    iconClassName: 'icon-three-euro-paper-bills font-size-3',
    link: RouteTypes.FARM_MILK_MILK_MONEY
  },
  {
    id: CLIMATE_CHECK_SLUG,
    slug: CLIMATE_CHECK_SLUG,
    title: 'Mein KlimaCheck',
    indicator: 0,
    iconClassName: 'leaf font-size-2-m',
    link: RouteTypes.CLIMATE_CHECK
  },
  {
    id: 'co2-climate-check',
    slug: CO2_LFL_SLUG,
    title: '<div>CO<sub>2</sub> Klima Check</div>',
    indicator: 0,
    iconClassName: 'leaf font-size-2-m',
    link: RouteTypes.CO2_CLIMATE
  },
  {
    id: 'milk-fixed-price',
    slug: MILK_FIXED_SLUG,
    title: i18n.t('Milk fixed price'),
    iconClassName: 'euro sign font-size-3',
    indicator: 0,
    link: RouteTypes.MILK_FIXED_PRICE
  },
  {
    id: 'milk_fixed_price_fat_and_protein',
    slug: FAT_PROTEIN_SLUG,
    title: i18n.t('Milk fixed price (F. & P.)'),
    link: RouteTypes.FAT_PROTEIN_PRICE,
    indicator: 0,
    iconClassName: 'euro sign font-size-3'
  },
  {
    id: MILK_STOCK_EXCHANGE,
    slug: MILK_STOCK_EXCHANGE,
    title: i18n.t('Stock exchange'),
    link: RouteTypes.STOCK_EXCHANGE,
    indicator: 0,
    iconClassName: 'euro sign font-size-3'
  },
  {
    id: 'reporting',
    title: i18n.t('Reporting'),
    slug: [MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE, FAT_PROTEIN_SLUG, CO2_LFL_SLUG],
    iconClassName: 'edit outline font-size-3',
    children: [
      {
        id: 'fat-protein-trading-activities',
        slug: FAT_PROTEIN_SLUG,
        title: i18n.t('Milk fixed price'),
        iconClassName: 'chart bar font-size-3',
        children: [
          {
            id: 'fat-protein-trading-activities',
            title: i18n.t('Trading activities'),
            iconClassName: 'chart bar font-size-2-m',
            link: RouteTypes.REPORTING_TRADING_ACTIVITIES.replace(':prefix', FixedPricePrefixType.FatProtein)
          },
          {
            id: 'fat-protein--price',
            title: i18n.t('Fixed price'),
            iconClassName: 'chart line font-size-2-m',
            link: RouteTypes.REPORTING_PRICE.replace(':prefix', FixedPricePrefixType.FatProtein)
          }
        ]
      },
      {
        id: 'fixed-price-trading-activities',
        slug: MILK_FIXED_SLUG,
        title: i18n.t('Milk fixed price'),
        iconClassName: 'chart bar font-size-3',
        children: [
          {
            id: 'trading-activities',
            title: i18n.t('Trading activities'),
            iconClassName: 'chart bar font-size-2-m',
            link: RouteTypes.REPORTING_TRADING_ACTIVITIES.replace(':prefix', FixedPricePrefixType.FixedPrice)
          },
          {
            id: 'fixed-farmer-price',
            title: i18n.t('Fixed price'),
            iconClassName: 'chart line font-size-2-m',
            link: RouteTypes.REPORTING_PRICE.replace(':prefix', FixedPricePrefixType.FixedPrice)
          }
        ]
      },
      {
        id: 'stock-exchange-trading-activities',
        slug: MILK_STOCK_EXCHANGE,
        title: i18n.t('Stock exchange'),
        iconClassName: 'chart bar font-size-3',
        children: [
          {
            id: 'trading-activities',
            title: i18n.t('Trading activities'),
            iconClassName: 'chart bar font-size-2-m',
            link: RouteTypes.REPORTING_TRADING_ACTIVITIES.replace(':prefix', FixedPricePrefixType.StockExchange)
          },
          {
            id: 'ble-farmer-price',
            title: i18n.t('BLE price'),
            iconClassName: 'chart line font-size-2-m',
            link: RouteTypes.REPORTING_PRICE.replace(':prefix', FixedPricePrefixType.StockExchange)
          }
        ]
      },
      {
        id: 'co2-climate-check-reporting',
        slug: CO2_LFL_SLUG,
        title: '<div>CO<sub>2</sub> Klima Check</div>',
        iconClassName: 'leaf font-size-2-m',
        children: [
          {
            id: 'data-collections',
            title: i18n.t('Data collections'),
            iconClassName: 'database font-size-2-m',
            link: RouteTypes.REPORTING_CO2
          }
        ]
      }
    ]
  },
  {
    id: 'cloud-storage',
    slug: 'cloud_storage',
    title: i18n.t('Cloud storage'),
    link: RouteTypes.CLOUD_STORAGE,
    iconClassName: 'cloud download font-size-3'
  },
  {
    id: 'newsletter',
    slug: 'newsletter',
    title: i18n.t('Newsletter'),
    iconClassName: 'icon-content font-size-3',
    indicator: 0,
    link: '/newsletter'
  },
  {
    id: 'faq',
    slug: 'faq',
    title: i18n.t('FAQ'),
    link: RouteTypes.FAQ,
    iconClassName: 'question circle outline font-size-3'
  },
  {
    id: 'milk-delivery-farmer',
    title: i18n.t('Milk delivery'),
    iconClassName: 'truck font-size-3',
    slug: MILK_MONEY_ACCOUNT_SLUG,
    link: RouteTypes.MILK_MONEY_DELIVERY
  },
  {
    id: 'milk-samples',
    title: i18n.t('Milk samples'),
    slug: MILK_MONEY_ACCOUNT_SLUG,
    iconClassName: 'icon-money-report font-size-3',
    link: '/milk-samples'
  },
  {
    id: 'survey',
    slug: 'survey',
    title: i18n.t('Survey'),
    link: RouteTypes.SURVEY,
    iconClassName: 'icon-survey font-size-3',
    indicator: 0
  }
];

export const getSideMenuFarmerManagerItems = () => [
  {
    id: 'farmers',
    title: i18n.t('Farmers'),
    iconClassName: 'icon-farmer-icon font-size-2-m',
    link: RouteTypes.DAIRY_FACTORY_FARMERS
  },
  {
    id: 'farmer-users',
    title: i18n.t('Farmer Users'),
    iconClassName: 'icon-user-group font-size-2-m',
    link: RouteTypes.DAIRY_FACTORY_FARMER_USERS
  },
  {
    id: 'climate-check',
    slug: CLIMATE_CHECK_SLUG,
    title: i18n.t('Climate check'),
    iconClassName: 'leaf font-size-2-m',
    link: RouteTypes.CLIMATE_CHECK
  },
  {
    id: 'milk-fixed-price',
    slug: 'milk_fixed_price_stock_exchange',
    title: i18n.t('Milk fixed price'),
    iconClassName: 'euro sign font-size-2-m',
    link: RouteTypes.MILK_FIXED_PRICE
  },
  {
    id: 'activity-logs',
    title: i18n.t('Activity Logs'),
    iconClassName: 'file text font-size-2-m',
    link: RouteTypes.DAIRY_FACTORY_PRICE_ACTIVITY_LOGS
  },
  {
    id: 'reporting',
    title: i18n.t('Reporting'),
    slug: [MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE, FAT_PROTEIN_SLUG, CO2_LFL_SLUG],
    iconClassName: 'edit outline font-size-3',
    children: [
      {
        id: 'co2-climate-check-reporting',
        slug: CO2_LFL_SLUG,
        title: '<div>CO<sub>2</sub> Klima Check</div>',
        iconClassName: 'leaf font-size-2-m',
        children: [
          {
            id: 'data-collections',
            title: i18n.t('Data collections'),
            iconClassName: 'database font-size-2-m',
            link: RouteTypes.REPORTING_CO2
          }
        ]
      }
    ]
  }
];

export const getSideMenuIfeItems = () => [
  {
    id: 'milk-fixed-price',
    slug: 'milk_fixed_price_stock_exchange',
    title: i18n.t('Milk fixed price'),
    iconClassName: 'euro sign font-size-2-m',
    link: RouteTypes.MILK_FIXED_PRICE
  },
  {
    id: MILK_STOCK_EXCHANGE,
    slug: MILK_STOCK_EXCHANGE,
    title: i18n.t('Stock exchange'),
    link: RouteTypes.STOCK_EXCHANGE,
    iconClassName: 'euro sign font-size-3'
  },
  {
    id: 'milk_fixed_price_fat_and_protein',
    slug: FAT_PROTEIN_SLUG,
    title: i18n.t('Milk fixed price (F. & P.)'),
    link: RouteTypes.FAT_PROTEIN_PRICE,
    iconClassName: 'euro sign font-size-3'
  }
];
